import { toast } from "react-toastify";
import { supabase } from "../../../context/useSupabaseContext";

export default async function deleteAccount() {
    const access_token = (await supabase.auth.getSession()).data.session.access_token;

    const deleteAccountResult = fetch(
        `${window.serverIP}/auth/delete-account`,
        {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                access_token: access_token,
            }),
        }
    )
        .then(async (res) => {
            return true;
        })
        .catch((err) => {
            return false;
        });

    toast.promise(deleteAccountResult, {
        pending: "Deleting account...",
        success: "Account deleted successfully",
        error: "Failed to delete account",
    });

    return deleteAccountResult;
}
